const _100_MB = 100 * 1024 * 1024;

export function isValidAttachFiles(stateFiles, filesAttach) {
	if ([...stateFiles, ...filesAttach].length > 10) {
    Popup.alert("１ファイル100MB以内・ファイル数は10個以内となります。");
    return false;
  }

  for (let i = 0; i < filesAttach.length; i++) {
    if (filesAttach[i].size > _100_MB) {
      Popup.alert("１ファイル100MB以内・ファイル数は10個以内となります。");
      return false;
    }
  }

  return true;
}

// FIX 20260929-bodymax コメント本文の文字数上限（3,000文字）。
//   数え方：装飾タグ・改行は数えず、見えている文字だけ（サーバー側 comment_body_limit.rb と同じ数え方）。
//   トースト：新しい画面は既存の .tmzs-toast（写す元 tmz_actdock.js note / tmz_akbar.js）、それ以外は従来の Popup.alert。
export const BODY_MAX_CHARS = 3000;

export function countBodyChars(html) {
  const s = String(html || '')
    .replace(/<[^>]*>/g, '')
    .replace(/&[a-zA-Z0-9#]+;/g, ' ')
    .replace(/[\r\n]/g, '');
  return Array.from(s).length;
}

function showBodyMaxToast(msg) {
  try { if (typeof window.tmToast === 'function') { window.tmToast(msg); return; } } catch (e) {}
  try { if (window.tmPanelBridge && typeof window.tmPanelBridge.toast === 'function') { window.tmPanelBridge.toast(msg); return; } } catch (e2) {}
  try {
    if (document.querySelector('link[href*="tmz_status"]')) {
      let t = document.getElementById('tmzBodyMaxToast');
      if (!t) { t = document.createElement('div'); t.id = 'tmzBodyMaxToast'; t.className = 'tmzs-toast'; document.body.appendChild(t); }
      const sp = document.createElement('span');
      sp.textContent = msg;
      t.innerHTML = '';
      t.appendChild(sp);
      t.classList.add('on');
      clearTimeout(t._t);
      t._t = setTimeout(function () { t.classList.remove('on'); }, 7000);
      return;
    }
  } catch (e3) {}
  Popup.alert(msg);
}

export function isValidBodyLength(html) {
  const n = countBodyChars(html);
  if (n <= BODY_MAX_CHARS) return true;
  showBodyMaxToast('コメントは' + BODY_MAX_CHARS.toLocaleString() + '文字以内で入力してください。（現在 ' + n.toLocaleString() + '文字）');
  return false;
}
